/**
 * Person feed display helpers — strip SERP HTML noise and shorten URLs.
 */

/**
 * Remove raw HTML tags (e.g. ``<strong>``) and decode a few common entities.
 *
 * @param {unknown} value
 * @returns {string}
 */
export function stripHtmlTags(value) {
  const raw = String(value ?? '');
  if (!raw) return '';
  return raw
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Hostname (or host+first path segment) for compact external link labels.
 *
 * @param {unknown} href
 * @returns {string}
 */
export function displayHostFromUrl(href) {
  const raw = String(href || '').trim();
  if (!raw) return '';
  try {
    const u = new URL(raw.includes('://') ? raw : `https://${raw}`);
    return (u.hostname || '').replace(/^www\./i, '') || raw;
  } catch {
    return raw.replace(/^https?:\/\//i, '').replace(/^www\./i, '').split(/[/?#]/)[0] || raw;
  }
}
